<template>
  <div class="cashPackContainer">
    <div class="dashboard">
      <div class="validAmount">
        <div class="amountTitle">待提现金额(元)</div>
        <div class="amount">
          {{ cashPackData.toBeWithdrawnAmount | centToYuan }}
        </div>
      </div>
      <div class="layoutWrapper">
        <div class="completeAmount">
          <div class="amountTitle">已提现(元)</div>
          <div class="amount">
            {{ cashPackData.withdrawnAmount | centToYuan }}
          </div>
        </div>
        <div class="pendingAmount">
          <div class="amountTitle">提现中(元)</div>
          <div class="amount">
            {{ cashPackData.withdrawingAmount | centToYuan }}
          </div>
        </div>
      </div>
      <div class="btn" @click="handleClickWithdraw">提现</div>
      <div class="badge" v-if="withdrawLimit > 0">
        满{{ withdrawLimit / 100 }}元可提现
      </div>
      <div class="pushWhere">
        申请提现后，将在7个工作日内提现至您的{{ cashType }}
      </div>
    </div>
    <div class="detail" v-if="mergedRecords.length">
      <div class="title">红包明细</div>
      <div class="recordList">
        <div class="record" v-for="record in mergedRecords" :key="record.id">
          <div>
            <div class="name" :class="transWithdrawStatus(record)">
              {{ record.comment }}
            </div>
            <div class="time">{{ record.occurTime | formatTime }}</div>
          </div>
          <div>
            <span class="amount" :class="{ fail: record.fail }"
              >{{ record.sign }}{{ record.amount | centToYuan }}</span
            >
            <span class="unit" :class="{ fail: record.fail }">元</span>
          </div>
        </div>
        <div class="noMore">没有更多了~</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { centToYuan, toDayDate } from '../../../helper';
import {
  throttle,
  isWeixinBrowser,
  isHllApp,
  isWxMiniProgram,
  getUrlParam,
  callApp
} from '@/utils';
import { wxAuth, getHllTicket } from '../../libs/wx';
const withdrawStatusMap = {
  // 1未达提现门槛；2账号异常提现失败；3提现中；4提现失败；5提现成功
  1: 'fail',
  2: 'fail',
  3: 'pending',
  4: 'fail',
  5: 'success'
};

export default {
  filters: {
    centToYuan: val => {
      return centToYuan(val, 2);
    },
    formatTime: val => {
      return toDayDate(val, 'yyyy.MM.dd hh:mm:ss');
    }
  },
  data() {
    return {
      test: this.actData
    };
  },
  created() {
    if (isWeixinBrowser() && this.isWithdrawToWX) {
      wxAuth();
    }
  },

  computed: {
    ...mapState('app/myAwards', {
      cashPackData: state => state.cashPackData
    }),
    ...mapState('app/lottery', {
      actData: state => state.actData,
      takeCashType: state => state.actData.takeCashType,
      taskCashLimit: state => state.actData.taskCashLimit || 0
    }),
    mergedRecords() {
      const userRewardDetails = (
        (this.cashPackData && this.cashPackData.userRewardDetails) ||
        []
      ).map(record => {
        return {
          ...record,
          sign: '+'
        };
      });
      const withdrawRecord = (
        (this.cashPackData && this.cashPackData.withdrawRecord) ||
        []
      ).map(record => {
        const isWithdrawFailed = withdrawStatusMap[record.status] === 'fail';
        return {
          ...record,
          sign: isWithdrawFailed ? '' : '-',
          fail: isWithdrawFailed,
          comment: record.statusStr
        };
      });
      userRewardDetails.push(...withdrawRecord);
      return userRewardDetails.sort(
        (recordA, recordB) => recordB.occurTime - recordA.occurTime
      );
    },
    isWithdrawToWX() {
      // 0 提现到微信零钱 1提现到用户钱包
      return this.takeCashType === 0;
    },
    cashType() {
      let pushWhere = this.takeCashType === 0 ? '微信零钱' : '司机钱包';
      return pushWhere;
    },
    withdrawLimit() {
      return this.taskCashLimit;
    }
  },
  methods: {
    ...mapActions('app/myAwards', ['submitWithdraw']),
    ...mapGetters('app/lottery', ['isOverActTime', 'isNotInWithdrawTime']),
    handleClickWithdraw: throttle(function() {
      if (this.isNotInWithdrawTime()) {
        this.$hll.toast('不在提现时间内');
        return;
      }
      if (this.isOverActTime()) {
        this.$hll.toast('活动已过期，无法提现');
        return;
      }
      if (this.cashPackData.toBeWithdrawnAmount <= 0) {
        this.$hll.toast('可提现金额为0');
        return;
      }
      if (this.cashPackData.toBeWithdrawnAmount < this.taskCashLimit) {
        this.$hll.toast(`满${centToYuan(this.taskCashLimit)}元才可提现哦`);
        return;
      }
      console.log(this.takeCashType, 'this.takeCashType--->');
      const templateCode = { code: getUrlParam('code') };
      // 提现到微信零钱
      if (this.isWithdrawToWX) {
        if (isWeixinBrowser()) {
          const hllTicket = getHllTicket();
          if (!hllTicket) {
            return wxAuth();
          }
          this.submitWithdraw({
            hllTicket,
            type: this.takeCashType,
            channel: 0,
            ...templateCode
          });
          return;
        } else if (isHllApp()) {
          let isProMini = /^[^-]+$/g.test(location.host);
          let url = `${location.origin}${location.pathname}?fromApp=cashout`;
          let uuid = getUrlParam('uuid') ? `&uuid=${getUrlParam('uuid')}` : '';
          let ref = getUrlParam('ref') ? `&ref=${getUrlParam('ref')}` : '';
          let p_uuid = getUrlParam('p_uuid')
            ? `&p_uuid=${getUrlParam('p_uuid')}`
            : '';
          let code = getUrlParam('code') ? '&code=' + getUrlParam('code') : '';
          const tpl = getUrlParam('tpl') ? '&tpl=' + getUrlParam('tpl') : '';
          const bl = getUrlParam('bl') ? '&bl=' + getUrlParam('bl') : '';
          const u = getUrlParam('u') ? '&u=' + getUrlParam('u') : '';
          const tabActive = '&currentTab=cashPack';
          url = `${url}${uuid}${ref}${p_uuid}${code}${tpl}${bl}${u}${tabActive}#/my_awards`;
          console.log(url, '小程序跳转路径---->');
          callApp(
            JSON.stringify({
              action: 'openWXMiniprogram',
              appName: 'gh_6b18e73b21cd',
              path: `pages/home/index?target=adv&targetUrl=${encodeURIComponent(
                url
              )}`,
              miniprogram_type: isProMini ? 0 : 2,
              miniprogramType: isProMini ? 0 : 2
            })
          );
          setTimeout(() => {
            this.$hll.toast('请在货拉拉小程序进入此活动完成微信提现操作');
          }, 1000);
          return;
        } else if (isWxMiniProgram()) {
          let token = getUrlParam('token');
          this.submitWithdraw({
            type: this.takeCashType,
            token,
            channel: 3,
            ...templateCode
          });
          return;
        }
        return this.$hll.toast('请在微信中进入活动提现');
      }
      this.submitWithdraw({ type: this.takeCashType, ...templateCode });
    }),
    transWithdrawStatus(record) {
      return withdrawStatusMap[String(record.status)] || '';
    }
  }
};
</script>

<style lang="less" scoped>
.cashPackContainer {
  box-sizing: border-box;
  width: 100%;
  padding: 24px;

  .amount {
    font-family: 'Alibaba Zhixing';
  }
}
.dashboard {
  position: relative;
  height: 600px;
  box-sizing: border-box;
  text-align: center;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);
  padding-top: 50px;

  .amountTitle {
    font-size: 30px;
    color: #8c8c8c;
  }

  .validAmount {
    font-size: 68px;
    color: #ff6600;
  }

  .layoutWrapper {
    margin: 56px 80px;
    display: flex;
    justify-content: space-between;

    .amount {
      font-size: 44px;
      color: #262626;
    }
  }

  .btn {
    margin: 0 auto;
    width: 560px;
    height: 88px;
    background: linear-gradient(to top, #ff7e00 0%, #ff9600 39%, #ffb80f 99%);
    border-radius: 44px;
    font-size: 40px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: normal;
  }

  .badge {
    position: absolute;
    top: 0;
    right: 0;
    padding: 6px 25px;
    background: #ffe9de;
    border-radius: 23px 0 0 23px;
    font-size: 26px;
    color: #ff6600;
  }
  .pushWhere {
    font-size: 26px;
    font-family: PingFang SC Regular, PingFang SC Regular-Regular;
    font-weight: 400;
    text-align: center;
    color: #ff6600;
    margin-top: 25px;
  }
}
.detail {
  margin-top: 40px;
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.04);

  .title {
    text-align: center;
    font-size: 36px;
    color: #262626;
    padding: 40px 0 24px;
  }

  .recordList {
    width: 100%;
    box-sizing: border-box;
    padding: 0 30px 10px;

    .record {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #e8e8e8;

      .name {
        font-size: 30px;
        color: #262626;

        &.success {
          color: #2dad69;
        }

        &.pending {
          color: #ffa600;
        }

        &.fail {
          color: #8c8c8c;
        }
      }

      .unit {
        font-size: 30px;
        color: #262626;

        &.fail {
          color: #8c8c8c;
        }
      }

      .time {
        font-size: 28px;
        color: #8c8c8c;
      }

      .amount {
        font-size: 42px;
        color: #262626;
        font-family: 'Alibaba Zhixing';

        &.fail {
          color: #8c8c8c;
        }
      }
    }

    .noMore {
      margin: 30px 0;
      text-align: center;
    }
  }
}
</style>
